export interface LoadingStateProps {
  label?: string;
}

export function LoadingState({ label = 'Loading…' }: LoadingStateProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex flex-col items-center justify-center gap-3 py-2xl text-text-secondary"
    >
      <span
        className="h-8 w-8 rounded-pill border-2 border-border border-t-primary animate-spin"
        aria-hidden="true"
      />
      <span className="text-sm">{label}</span>
    </div>
  );
}
